// validate URL to protect against XSS

export const validateUrl = (url: string | undefined) => {
  if (url === undefined) return undefined;
  try {
    const parsedUrl = new URL(url);
    if (parsedUrl.protocol === "https:" || parsedUrl.protocol === "http:") {
      return url;
    } else {
      // TODO: maybe this should be undefined as well?
      return "https://semgrep.dev";
    }
  } catch {
    return undefined;
  }
};
